exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ir-reports-tab-hints{width:38%;float:right}.ir-reports-tab-hints h4{color:#27638c;font-size:18px;font-weight:700}.ir-reports-tab-hints ol{margin:.75em 0 1.25em;padding:0;font-size:14px}.ir-reports-tab-hints ol li{padding:0 0 .3em;margin:.15em 0 .15em 2em}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/pages/filings/SearchCourtRecords/ReportsTab/Hints/hints.less
 ** module id = 1096
 ** module chunks = 0
 **/